
// 保障权益
const bzqy = [{
    title: '境外旅行意外伤害保险（互联网专属）',
    planA: '¥300,000',
    planB: '¥500,000',
    planC: '¥1,000,000'
}, {
    title: '附加公共交通工具意外伤害保险（互联网专属）',
    planA: '',
    planB: '¥500,000',
    planC: '¥1,000,000'
}, {
    title: '附加旅行医疗费用保险（互联网专属）',
    planA: '¥300,000',
    planB: '¥400,000',
    planC: '¥600,000'
}, {
    title: '附加旅行意外住院津贴保险（互联网专属）',
    planA: '',
    planB: '¥100元/天 (90日为限）',
    planC: '¥200元/天 (90日为限）'
}, {
    title: '附加医疗运送',
    planA: '¥300,000',
    planB: '¥500,000',
    planC: '¥1,000,000'
}, {
    title: '附加家属慰问探望保险',
    planA: '',
    planB: '单张单程经济舱机票 \n（限额 ¥10,000)',
    planC: '单张单程经济舱机票 \n（限额 ¥20,000)'
}, {
    title: '身故遗体送返 (丧葬费用限2万)',
    planA: '¥300,000',
    planB: '¥500,000',
    planC: '¥1,000,000'
}, {
    title: '附加个人行李及随身物品保险',
    planA: '',
    planB: '¥3,000 \n(单件物品赔付限额¥1,000）',
    planC: '¥5,000 \n(单件物品赔付限额¥1,000）'
}, {
    title: '附加行李延误保险金',
    planA: '',
    planB: '¥1,500  \n行李延误(每8小时赔偿¥500)',
    planC: '¥1,500  \n行李延误(每8小时赔偿¥500)'
}, {
    title: '附加个人现金丢失保险',
    planA: '',
    planB: '¥1,500',
    planC: '¥2,000'
}, {
    title: '附加旅行证件丢失保险',
    planA: '',
    planB: '¥5,000',
    planC: '¥8,000'
}, {
    title: '附加航班延误保险',
    planA: '',
    planB: '¥500 \n(每5小时延误赔付¥250)',
    planC: '¥500 \n(每5小时延误赔付¥250)'
}, {
    title: '旅行缩短（含新冠保障）',
    planA: '',
    planB: '',
    planC: '¥5,000'
}, {
    title: '旅行取消（含新冠保障）',
    planA: '',
    planB: '¥5,000',
    planC: '¥8,000'
}, {
    title: '个人第三者责任',
    planA: '',
    planB: '¥100,000',
    planC: '¥200,000'
}, {
    title: '信用卡盗刷 (不适用于未成年人)',
    planA: '',
    planB: '¥10,000',
    planC: '¥10,000'
}, {
    title: '签证拒签',
    planA: '',
    planB: '¥700',
    planC: '¥700'
}, {
    title: '高风险运动',
    planA: '包含 Yes',
    planB: '包含 Yes',
    planC: '包含 Yes'
},{
    title: '未成年子女送返',
    planA: '单张单程经济舱机票 \n（限额 ¥5,000)',
    planB: '单张单程经济舱机票 \n（限额 ¥10,000)',
    planC: '单张单程经济舱机票 \n（限额 ¥20,000)'
}, {
    title: '提供境外住院医疗直付服务',
    planA: '',
    planB: '包含 Yes',
    planC: '包含 Yes'
}, {
    title: '协调境外陪诊服务',
    planA: '',
    planB: '包含 Yes',
    planC: '包含 Yes'
}, {
    title: '旅行目的地医疗机构推荐',
    planA: '',
    planB: '',
    planC: '包含 Yes'
}, {
    title: '旅行目的地法律援助推荐',
    planA: '',
    planB: '',
    planC: '包含 Yes'
}, {
    title: '旅行目的地紧急信息和文件的传递',
    planA: '',
    planB: '',
    planC: '包含 Yes'
}, {
    title: '紧急在线翻译服务（中英）',
    planA: '',
    planB: '',
    planC: '包含 Yes'
}];
const bzqyEn = [{
    title: 'Overseas Travel Accident Injury Insurance（Online-Only Sales）',
    planA: '¥300,000',
    planB: '¥500,000',
    planC: '¥1,000,000'
}, {
    title: 'Public transport means accident injury insurance（Online-Only Sales）',
    planA: '',
    planB: '¥500,000',
    planC: '¥1,000,000'
}, {
    title: 'Travel Medical Expenses（Online-Only Sales）',
    planA: '¥300,000',
    planB: '¥400,000',
    planC: '¥600,000'
}, {
    title: 'Accidental Hospital Income（Online-Only Sales）',
    planA: '',
    planB: '¥100元/天 (90日为限）',
    planC: '¥200元/天 (90日为限）'
}, {
    title: 'Medical Evacuation and Repatriation',
    planA: '¥300,000',
    planB: '¥500,000',
    planC: '¥1,000,000'
}, {
    title: 'Compassionate Visit',
    planA: '',
    planB: '单张单程经济舱机票 \n（限额 ¥10,000)',
    planC: '单张单程经济舱机票 \n（限额 ¥20,000)'
}, {
    title: 'Repatriation Insurance',
    planA: '¥300,000',
    planB: '¥500,000',
    planC: '¥1,000,000'
}, {
    title: 'Baggage Lost or Destroy Insurance',
    planA: '',
    planB: '¥3,000 \n(单件物品赔付限额¥1,000）',
    planC: '¥5,000 \n(单件物品赔付限额¥1,000）'
}, {
    title: 'Baggage Delay',
    planA: '',
    planB: '¥1,500  \n行李延误(每8小时赔偿¥500)',
    planC: '¥1,500  \n行李延误(每8小时赔偿¥500)'
}, {
    title: 'Loss of Personal Money Insurance',
    planA: '',
    planB: '¥1,500',
    planC: '¥2,000'
}, {
    title: 'Loss of Travel Document Insurance',
    planA: '',
    planB: '¥5,000',
    planC: '¥8,000'
}, {
    title: 'Flight  Delay Insurance',
    planA: '',
    planB: '¥500 \n(每5小时延误赔付¥250)',
    planC: '¥500 \n(每5小时延误赔付¥250)'
}, {
    title: 'Trip Shortening ( Cov-19 Covered )',
    planA: '',
    planB: '',
    planC: '¥5,000'
}, {
    title: 'Trip Cancellation ( Cov-19 Covered )',
    planA: '',
    planB: '¥5,000',
    planC: '¥8,000'
}, {
    title: 'Personal Liability',
    planA: '',
    planB: '¥100,000',
    planC: '¥200,000'
}, {
    title: 'Credit Card Fraudulent Charges (not applicable to Minor)',
    planA: '',
    planB: '¥10,000',
    planC: '¥10,000'
}, {
    title: 'Visa Refusal Insurance',
    planA: '',
    planB: '¥700',
    planC: '¥700'
}, {
    title: 'High Risk Sports Insurance（Online-Only Sales）',
    planA: '包含 Yes',
    planB: '包含 Yes',
    planC: '包含 Yes'
}, {
    title: '未成年子女送返',
    planA: '单张单程经济舱机票 \n（限额 ¥5,000)',
    planB: '单张单程经济舱机票 \n（限额 ¥10,000)',
    planC: '单张单程经济舱机票 \n（限额 ¥20,000)'
}, {
    title: '提供境外住院医疗直付服务',
    planA: '',
    planB: '包含 Yes',
    planC: '包含 Yes'
}, {
    title: '协调境外陪诊服务',
    planA: '',
    planB: '包含 Yes',
    planC: '包含 Yes'
}, {
    title: '旅行目的地医疗机构推荐',
    planA: '',
    planB: '',
    planC: '包含 Yes'
}, {
    title: '旅行目的地法律援助推荐',
    planA: '',
    planB: '',
    planC: '包含 Yes'
}, {
    title: '旅行目的地紧急信息和文件的传递',
    planA: '',
    planB: '',
    planC: '包含 Yes'
}, {
    title: '紧急在线翻译服务（中英）',
    planA: '',
    planB: '',
    planC: '包含 Yes'
}];
const plan1 = [{
    min: 1,
    max: 3,
    value: 97
}, {
    min: 4,
    max: 5,
    value: 129
}, {
    min: 5,
    max: 7,
    value: 163,
}, {
    min: 8,
    max: 10,
    value: 215
}, {
    min: 11,
    max: 14,
    value: 297
}, {
    min: 15,
    max: 17,
    value: 327
}, {
    min: 18,
    max: 25,
    value: 432
}, {
    min: 26,
    max: 28,
    value: 523
}, {
    avg: 111,
    year: 2097
}];
const plan2 = [{
    min: 1,
    max: 3,
    value: 176
}, {
    min: 4,
    max: 5,
    value: 216
}, {
    min: 5,
    max: 7,
    value: 258,
}, {
    min: 8,
    max: 10,
    value: 326
}, {
    min: 11,
    max: 14,
    value: 433
}, {
    min: 15,
    max: 17,
    value: 473
}, {
    min: 18,
    max: 25,
    value: 607
}, {
    min: 26,
    max: 28,
    value: 726
}, {
    avg: 145,
    year: 2796
}];
const plan3 = [{
    min: 1,
    max: 3,
    value: 221
}, {
    min: 4,
    max: 5,
    value: 273
}, {
    min: 5,
    max: 7,
    value: 328,
}, {
    min: 8,
    max: 10,
    value: 418
}, {
    min: 11,
    max: 14,
    value: 563
}, {
    min: 15,
    max: 17,
    value: 613
}, {
    min: 18,
    max: 25,
    value: 790
}, {
    min: 26,
    max: 28,
    value: 947
}, {
    avg: 192,
    year: 3680
}];
const planPremiumTable = {
    1: plan1,
    2: plan2,
    3: plan3
}
const calcPremium = (plan, days) => {
    let sum = 0
    const plan1 = planPremiumTable[plan]
    if (days == 'year') {
        sum = plan1[plan1.length - 1].year
    } else if (days > 28) {
        let num = Math.floor(days / 7) + (days % 7 == 0 ? 0 : 1)
        sum = plan1[plan1.length - 2].value + plan1[plan1.length - 1].avg * (num - 4)
    } else {
        const item = plan1.filter(item => {
            return item.min <= days && days <= item.max
        })
        sum = item[0].value
    }
    console.log('计算保费 -> ', plan, days, sum, planPremiumTable, plan1)
    return sum.toFixed(1)
}
const premiumRules = [{
    days: '1-3',
    plan1: '97',
    plan2: '176',
    plan3: '221'
}, {
    days: '4-5',
    plan1: '129',
    plan2: '216',
    plan3: '273'
}, {
    days: '6-7',
    plan1: '163',
    plan2: '258',
    plan3: '328'
}, {
    days: '8—10',
    plan1: '215',
    plan2: '326',
    plan3: '418'
}, {
    days: '11-14',
    plan1: '297',
    plan2: '433',
    plan3: '563'
}, {
    days: '15-17',
    plan1: '327',
    plan2: '473',
    plan3: '613'
}, {
    days: '18-25',
    plan1: '432',
    plan2: '607',
    plan3: '790'
}, {
    days: '26-28',
    plan1: '523',
    plan2: '726',
    plan3: '947'
}, {
    days: '每增加一周',
    plan1: '111',
    plan2: '145',
    plan3: '192'
}, {
    days: '1年（每次旅行的保障期限最长为90天）',
    plan1: '2097',
    plan2: '2796',
    plan3: '3680'
}];
const notileColumns = [
    {
        title: '',
        dataIndex: 'title',
        key: 'title',
        width: 300,
    }, 
    {
        title: '',
        dataIndex: 'content',
        key: 'content'
    }
]
const notileRules = [
    {
        title: '特别约定：',
        content: '1.请注意对于被保险人不满10周岁的，身故给付的保险金额总和不得超过人民币20万元；对于被保险人已满10周岁不满18周岁的，身故给付的保险金额总和不得超过人民币50万元. \n2.本保险保障您（被保险人）因遭受意外伤害事故或罹患突发性疾病导致的医疗费用报销以及紧急医疗转运和送返。具体保障项目以条款为准。\n3.年龄限制在出生满为60天-80周岁（含60天和80周岁）。4.在同一保险期间内，每位被保险人仅限投保一份旅行保险。超出部分无效。5.医疗送返的目的地为您在中国大陆的居住地。6.除外国家和地区：（1）中国大陆；（2）阿富汗、亚美尼亚、阿塞拜疆、白俄罗斯、缅甸、布隆迪、中非共和国、古巴、刚果共和国、埃及、厄立特里亚、几内亚、几内亚比绍共和国、海地、伊朗、伊拉克、黎巴嫩、利比亚、马里、尼加拉瓜、朝鲜、俄罗斯、索马里、南苏丹、苏丹、叙利亚、突尼斯、乌克兰、委内瑞拉、波黑、黑山、塞尔维亚、也门、津巴布韦等依据联合国或欧盟、中华人民共和国或美国的贸易或经济制裁措施、法律或法规，导致我们履行保险本合同可能遭受任何制裁、禁令或限制令的国家或地区；（3）救援公司无法提供服务的国家或地区。7.每次承保旅程最长期限为90天。8.本保险不承保既往病症。9.任何由于计算机系统（包括但不限于电脑，硬件，软件，通信系统，网络设备，电子设备，云，服务器等）的无法使用，疏忽错误，数据异常，功能缺失，更换维修，未授权行为，恶意行为或非法行为等原因，直接或间接引起或促成与之相关的任何损失，责任和费用等，保险人不负责赔偿。'
      }
];
const notileRulesEn = [
    {
        title: '特别约定：',
        content: '1.请注意对于被保险人不满10周岁的，身故给付的保险金额总和不得超过人民币20万元；对于被保险人已满10周岁不满18周岁的，身故给付的保险金额总和不得超过人民币50万元. \n2.本保险保障您（被保险人）因遭受意外伤害事故或罹患突发性疾病导致的医疗费用报销以及紧急医疗转运和送返。具体保障项目以条款为准。\n3.年龄限制在出生满为60天-80周岁（含60天和80周岁）。4.在同一保险期间内，每位被保险人仅限投保一份旅行保险。超出部分无效。5.医疗送返的目的地为您在中国大陆的居住地。6.除外国家和地区：（1）中国大陆；（2）阿富汗、亚美尼亚、阿塞拜疆、白俄罗斯、缅甸、布隆迪、中非共和国、古巴、刚果共和国、埃及、厄立特里亚、几内亚、几内亚比绍共和国、海地、伊朗、伊拉克、黎巴嫩、利比亚、马里、尼加拉瓜、朝鲜、俄罗斯、索马里、南苏丹、苏丹、叙利亚、突尼斯、乌克兰、委内瑞拉、波黑、黑山、塞尔维亚、也门、津巴布韦等依据联合国或欧盟、中华人民共和国或美国的贸易或经济制裁措施、法律或法规，导致我们履行保险本合同可能遭受任何制裁、禁令或限制令的国家或地区；（3）救援公司无法提供服务的国家或地区。7.每次承保旅程最长期限为90天。8.本保险不承保既往病症。9.任何由于计算机系统（包括但不限于电脑，硬件，软件，通信系统，网络设备，电子设备，云，服务器等）的无法使用，疏忽错误，数据异常，功能缺失，更换维修，未授权行为，恶意行为或非法行为等原因，直接或间接引起或促成与之相关的任何损失，责任和费用等，保险人不负责赔偿。'
      }
];
const premiumRulesEn = [{
    days: '1-3',
    plan1: '97',
    plan2: '176',
    plan3: '221'
}, {
    days: '4-5',
    plan1: '129',
    plan2: '216',
    plan3: '273'
}, {
    days: '6-7',
    plan1: '163',
    plan2: '258',
    plan3: '328'
}, {
    days: '8—10',
    plan1: '215',
    plan2: '326',
    plan3: '418'
}, {
    days: '11-14',
    plan1: '297',
    plan2: '433',
    plan3: '563'
}, {
    days: '15-17',
    plan1: '327',
    plan2: '473',
    plan3: '613'
}, {
    days: '18-25',
    plan1: '432',
    plan2: '607',
    plan3: '790'
}, {
    days: '26-28',
    plan1: '523',
    plan2: '726',
    plan3: '947'
}, {
    days: 'one week after 4 weeks',
    plan1: '111',
    plan2: '145',
    plan3: '192'
}, {
    days: '1 year with 90 days per trip max',
    plan1: '2097',
    plan2: '2796',
    plan3: '3680'
},]
const premiumColumns = [{
    title: '保险期间（天）',
    dataIndex: 'days',
    key: 'days',
    width: 300,
}, {
    title: '保险计划',
    children: [{
        title: '经济计划',
        dataIndex: 'plan1',
        key: 'plan1'
    }, {
        title: '升级计划',
        dataIndex: 'plan2',
        key: 'plan2'
    }, {
        title: '白金计划',
        dataIndex: 'plan3',
        key: 'plan3'
    }]
}]
const premiumColumnsEn = [{
    title: 'Duration（day）',
    dataIndex: 'days',
    width: 300,
    key: 'days'
}, {
    title: 'Insurance Plan',
    children: [{
        title: 'Economic Plan',
        dataIndex: 'plan1',
        key: 'plan1'
    }, {
        title: 'Advance Plan',
        dataIndex: 'plan2',
        key: 'plan2'
    }, {
        title: 'Pemium Plan',
        dataIndex: 'plan3',
        key: 'plan3'
    }]
}]
const planDays = ['1-3', '4-5', '6-7', '8-10', '11-14', '15-17', '18-25', '26-28'];
const columns = [
    {
        title: "中银-申根保障计划",
        dataIndex: "title",
        key: "title",
        width: 300,
    },
    {
        title: "经济计划",
        dataIndex: "planA",
        key: "planA",
    },
    {
        title: "升级计划",
        dataIndex: "planB",
        key: "planB",
    },
    {
        title: "白金计划",
        dataIndex: "planC",
        key: "planC",
    },
];
const columnsEn = [
    {
        title: "Vasco Tender",
        dataIndex: "title",
        key: "title",
        width: 300,
    },
    {
        title: "Economic Plan",
        dataIndex: "planA",
        key: "planA",
    },
    {
        title: "Advance Plan",
        dataIndex: "planB",
        key: "planB",
    },
    {
        title: "Premium Plan",
        dataIndex: "planC",
        key: "planC",
    },
];
const plans = ['中银-申根保障计划(含新冠医疗)(互联网)经济计划', '中银-申根保障计划(含新冠医疗)(互联网)升级计划', '中银-申根保障计划(含新冠医疗)(互联网)白金计划',
    '中银-申根保障计划(含新冠医疗)(互联网)年单经济计划', '中银-申根保障计划(含新冠医疗)(互联网)年单升级计划', '中银-申根保障计划(含新冠医疗)(互联网)年单白金计划'
];
const plansEn = ['BOCI Schengen Insurance Plan - Economic', 'BOCI Schengen Insurance Plan - Advance',
    'BOCI Schengen Insurance Plan - Pemium', 'BOCI Schengen Insurance Plan - Annual Economic',
    'BOCI Schengen Insurance Plan - Annual Advance', 'BOCI Schengen Insurance Plan - Annual Pemium'
];
export {
    plans,
    plansEn,
    columns,
    columnsEn,
    planDays,
    bzqy,
    bzqyEn,
    notileColumns,
    notileRulesEn,
    notileRules,
    calcPremium,
    premiumRules,
    premiumRulesEn,
    premiumColumns,
    premiumColumnsEn,
}